export function navDrawer() {
    const menu = document.getElementById('menu');
    const toggle = document.getElementById('menu-button');
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute#Polyfill
    if (!Element.prototype.toggleAttribute) {
        Element.prototype.toggleAttribute = function(name, force) {
            if (force !== void 0) force = !!force;
            if (this.getAttribute(name) !== null) {
                if (force) return true;
                this.removeAttribute(name);
                return false;
            } else {
                if (force === false) return false;
                this.setAttribute(name, '');
                return true;
            }
        };
    }
    toggle.addEventListener('click', () => {
        menu.toggleAttribute('aria-expanded');
        toggle.toggleAttribute('aria-expanded');
    });

    //SIMON: added android check on resize
    window.addEventListener('resize', () => {
        if ((getMobileOperatingSystem()) != 'Android') {
            menu.removeAttribute('aria-expanded');
            toggle.removeAttribute('aria-expanded');
        }
    });

    /**
     * Determine the mobile operating system.
     * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
     *
     * @returns {String}
     */
    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
        return "unknown";
    }

}




// USED FOR THE RC CONTEST LIGHTBOX/SLIDESHOW

/*
jQuery(function($) {
    // $("form input").click(function() {
    //     // alert('search');
    // });


    // $("#pc_photo-name").click(function() {
    //     // alert('image_id1 + image_id2 ' + $image_id + ' -- ' + $image_id2);
    //     // alert('search');
    //     // alert('search');
    // });

    if ($("body").is("[page-type='contest']")) {
        // success
// alert('ss');


$('.rc-slideshow').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 6000,
    fade: true,
    cssEase: 'linear'
});



}
else {
    // does not have
    // alert('nn');
}

}); 
*/
